import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "@/core/data/img/ImageWithBasePath";
import { all_routes } from "@/feature-module/router/all-routes";

interface TestimonialItemProps {
  id?: string | number;
  title: string;
  content: string;
  imagePath: string;
  name: string;
  category: string;
  altText?: string;
}

const TestimonialItem: React.FC<TestimonialItemProps> = ({
  id,
  title,
  content,
  imagePath,
  name,
  category,
  altText = "User"
}) => {
  const routes = all_routes;
  // Check if imagePath is a full URL (starts with http) or a local path
  const isFullUrl = imagePath.startsWith("http");
  
  // Build the detail page URL
  const detailUrl = id ? routes.testimonialDetail.replace(':id', String(id)) : '#';
  
  return (
    <div className="testimonial-group w-100 h-100 d-flex flex-column">
      <div className="testimonial-review flex-grow-1">
        <Link to={detailUrl} style={{ textDecoration: 'none', color: 'inherit' }}>
          <h5 className="hover-underline">{title}</h5>
        </Link>
        <p>{content}</p>
      </div>
      <div className="listing-venue-owner">
        <Link to={detailUrl} className="navigation">
          {isFullUrl ? (
            <img src={imagePath} alt={altText} className="img-fluid" />
          ) : (
            <ImageWithBasePath src={imagePath} alt={altText} />
          )}
        </Link>
        <div className="testimonial-content">
          <h5>{name}</h5>
          <span className="btn btn-primary" style={{ cursor: 'default' }}>
            {category}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialItem;
